
/**
 * 강의 난이도
 */
export type CourseListResponseCoursesItemLevel = typeof CourseListResponseCoursesItemLevel[keyof typeof CourseListResponseCoursesItemLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseListResponseCoursesItemLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
